import * as requestFromServer from "./crud";
import {linksSlice, callTypes} from "./slices";
import {convertFilter} from "../../../utils/commonUtils";

const {actions} = linksSlice;

export const fetchLinks = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const _filter = convertFilter(queryParams);

  return requestFromServer
    .getLinksByFilter(_filter)
    .then(response => {
      const {pageInfo: {totalCnt}, saleLinkList} = response;
      dispatch(actions.linksFetched({totalCnt, saleLinkList}));
    })
    .catch(error => {
      error.clientMessage = "Can't find links";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const fetchLink = linkId => dispatch => {
  if (!linkId) {
    return dispatch(actions.linkFetched({link: undefined}));
  }
  dispatch(actions.startCall({callType: callTypes.action}));
  return requestFromServer
    .getLinkById(linkId)
    .then(response => {
      const link = response;
      dispatch(actions.linkFetched({link}));
    })
    .catch(error => {
      error.clientMessage = "Can't find link";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

